export const THEMES = {
   BRAND: "brand",
   INFO: "info",
   SUCCESS: "success",
   WARNING: "warning",
   DANGER: "danger",
   NEUTRAL: "neutral",
} as const;

export type Theme = (typeof THEMES)[keyof typeof THEMES];

export const COLOUR_THEMES = {
   GREEN: "green",
   RED: "red",
   BLUE: "blue",
   BRAND: "brand",
   ORANGE: "orange",
   PURPLE: "purple",
   NEUTRAL: "neutral",
   PINK: "pink",
   SAND: "sand",
   TAN: "tan",
} as const;

export type ColourTheme = (typeof COLOUR_THEMES)[keyof typeof COLOUR_THEMES];
